import { History, Trophy } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const StoriaPage = () => {
  const storia = [
    {
      year: "1919",
      title: "La Nascita",
      text: "Su iniziativa di una decina di amici, nasce l'U.S. Volpianese. La Società bianconera, sorretta dalla passione dei soci e simpatizzanti, raggiunge nell'immediato dopo guerra, la serie C, arrivando a sfiorare addirittura la serie B."
    },
    {
      year: "1929",
      title: "Il Virtus",
      text: "Dieci anni più tardi compare un altro gruppo sportivo sulla scena: Il Virtus, che si sviluppa e prende vita dall'Oratorio, sale immediatamente alla ribalta, conquistando le simpatie e l'affetto dei giovani volpianesi."
    },
    {
      year: "1970",
      title: "La Fusione",
      text: "Rivali per breve tempo, le due società si fondono per costruire l'A.S. Volpiano, un sodalizio di successi che culminerà con la partecipazione, per due anni consecutivi, al campionato di serie D, alla fine del millennio."
    },
    {
      year: "2001",
      title: "F.C. Canavese",
      text: "Fu l'anno della fusione con l'U.S. Sangiustese dalla quale nacque la F.C. Canavese ma a differenza della precedente, questa unione non funzionò e l'anima volpianese ben presto lasciò la conduzione della nuova società."
    },
    {
      year: "2006",
      title: "Il Ritorno",
      text: "Due anni dopo la morte del Presidente Giovanni Rolle, la dirigenza storica dell'A.S. Volpiano tornò nel mondo del calcio entrando nel direttivo della G.S.D. Volpianese, società fondata nel 1986. L'anno seguente la denominazione sociale viene cambiata in G.S.D. Volpiano."
    },
    {
      year: "Oggi",
      title: "100 Anni di Storia",
      text: "Il G.S.D. Volpiano si appresta a festeggiare i 100 anni di calcio presentandosi come una delle realtà più importanti del panorama calcistico Piemontese a livello dilettantistico, l'unica a poter vantare la vittoria di due titoli Juniores Regionali consecutivi (Stagioni 2013/14 e 2014/15)."
    },
  ];

  return (
    <div data-testid="storia-page">
      <Navbar />

      {/* Hero */}
      <section className="pt-24 lg:pt-32 pb-12 bg-[#0047AB] noise-overlay">
        <div className="max-w-7xl mx-auto px-4 text-center text-white">
          <h1 className="text-4xl lg:text-5xl font-black uppercase mb-4 animate-fade-in-up">
            La Nostra Storia
          </h1>
          <p className="text-blue-200 max-w-xl mx-auto">
            Oltre 100 anni di passione, tradizione e successi
          </p>
        </div>
      </section>

      {/* Storia della Società */}
      <section className="section-padding bg-white" data-testid="storia-section">
        <div className="max-w-4xl mx-auto px-4">
          {/* Timeline */}
          <div className="relative">
            {/* Timeline line */}
            <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-[#0047AB]/20 transform md:-translate-x-1/2"></div>

            <div className="space-y-8">
              {storia.map((item, index) => (
                <div
                  key={index}
                  className={`relative flex flex-col md:flex-row gap-4 md:gap-8 ${
                    index % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"
                  }`}
                >
                  {/* Year badge */}
                  <div className="absolute left-4 md:left-1/2 w-8 h-8 bg-[#0047AB] rounded-full flex items-center justify-center transform -translate-x-1/2 z-10">
                    <div className="w-3 h-3 bg-white rounded-full"></div>
                  </div>

                  {/* Content */}
                  <div className={`ml-12 md:ml-0 md:w-1/2 ${index % 2 === 0 ? "md:pr-12 md:text-right" : "md:pl-12"}`}>
                    <div className="bg-slate-50 rounded-xl p-6 hover:shadow-md transition-shadow">
                      <span className="inline-block text-sm font-bold text-[#0047AB] bg-blue-50 px-3 py-1 rounded-full mb-3">
                        {item.year}
                      </span>
                      <h3 className="text-lg font-bold text-slate-900 mb-2">
                        {item.title}
                      </h3>
                      <p className="text-slate-600 text-sm leading-relaxed">
                        {item.text}
                      </p>
                    </div>
                  </div>

                  {/* Spacer for alternating layout */}
                  <div className="hidden md:block md:w-1/2"></div>
                </div>
              ))}
            </div>
          </div>

          {/* Achievements */}
          <div className="mt-16 bg-gradient-to-r from-[#0047AB] to-[#003380] rounded-2xl p-8 text-center text-white">
            <Trophy className="w-12 h-12 mx-auto mb-4 opacity-80" />
            <h3 className="text-xl font-bold mb-2">Palmares</h3>
            <p className="text-blue-200 text-sm">
              2 Titoli Juniores Regionali Consecutivi (2013/14 - 2014/15)
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default StoriaPage;
